import { api } from "app/data/api";

export const getAddressByZipCode = async  (zipCode: string) => {
    return await api.get(`https://viacep.com.br/ws/${zipCode}/json/`, {})
}